import * as React from "react";
import { ThemeContext } from "./index";

export const useTheme = () => React.useContext(ThemeContext);
